/**
 * FleetManager V3 - Teams Widget
 * Compact teams overview card for the dashboard - clickable to navigate to teams view
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Users, ChevronRight, User, Car, Wrench } from 'lucide-react';
import { Card, CardHeader, CardTitle } from '../../shared/index.js';

export function TeamsWidget({ data = {}, onNavigate }) {
  const { t } = useTranslation();
  const {
    total_teams = 0,
    active_teams = 0,
    total_members = 0,
    members_by_type = {}
  } = data;

  const handleClick = () => {
    onNavigate?.('teams');
  };

  return (
    <Card
      className="cursor-pointer hover:ring-1 hover:ring-indigo-500/50 transition-all"
      onClick={handleClick}
    >
      <CardHeader>
        <CardTitle icon={Users} iconColor="text-indigo-500 dark:text-indigo-400">
          {t('dashboard.teams.title')}
        </CardTitle>
        <ChevronRight className="h-4 w-4 text-gray-400" />
      </CardHeader>

      <div className="px-4 pb-4">
        {/* Main stat */}
        <div className="flex items-baseline gap-2 mb-3">
          <span className="text-2xl font-bold text-gray-900 dark:text-gray-100">{active_teams}</span>
          <span className="text-sm text-gray-500 dark:text-gray-400">
            {t('dashboard.teams.active', { count: active_teams, total: total_teams })}
          </span>
        </div>

        {/* Member breakdown */}
        <div className="flex items-center gap-4 text-sm">
          <span className="flex items-center gap-1 text-gray-600 dark:text-gray-400">
            <User className="h-3.5 w-3.5" />
            {members_by_type.drivers || 0}
          </span>
          <span className="flex items-center gap-1 text-gray-600 dark:text-gray-400">
            <Car className="h-3.5 w-3.5" />
            {members_by_type.vehicles || 0}
          </span>
          <span className="flex items-center gap-1 text-gray-600 dark:text-gray-400">
            <Wrench className="h-3.5 w-3.5" />
            {members_by_type.tools || 0}
          </span>
          <span className="ml-auto text-xs text-gray-400">
            {t('dashboard.teams.members', { count: total_members })}
          </span>
        </div>
      </div>
    </Card>
  );
}
